<template>
    <v-dialog v-model="dialogVariazioni" max-width="1200px" :persistent="true">
      <v-card min-height="700" >
        <v-card-text>
          <v-tabs v-model="tabs">
            <v-tab key="variazioni">Variazioni</v-tab>
            <v-tab key="preparazioni">Preparazioni</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item key="variazioni">
              <v-tabs v-model="tabsVariazioni">
                <v-tab v-for="(variazione, index) in variazioni" :key="index">{{ variazione.categoria }}</v-tab>
                <!-- <v-btn icon title="Aggiungi un elemento" class="ml-3 mt-2" @click="tabsAddElement(variazione)"><v-icon>mdi-table-column-plus-after</v-icon></v-btn> -->
              </v-tabs>
              <v-tabs-items v-model="tabsVariazioni">
                <v-tab-item v-for="(item, vdx) in variazioni" :key="vdx">
                  <v-container fluid>
                    <v-row no-gutters>  
                      <v-col>
                        <v-data-table
                          v-model="variazioniSelected"
                          :headers="variazioniHeaders"
                          :items="item.variazioni"
                          item-key="codice"
                          show-select
                          class="elevation-1"
                        >
                        <template v-slot:top>
                          <v-toolbar flat>
                            <v-toolbar-title>Seleziona le variazioni da aggiungere</v-toolbar-title>
                            <v-btn class = "ml-5" small color="success" @click.stop="onAggiungiTutteVariazioni(item.categoria)">Seleziona tutte</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn class = "ml-5" small color="primary" @click.stop="onAggiungiVariazioniAlProdotto(item.categoria, item)">Aggiungi al prodotto</v-btn>
                          </v-toolbar>
                        </template>                          
                          <template v-slot:[`item.isProdotto`]="{ item }">
                            {{ item.isProdotto ? 'SI' : 'NO' }}
                          </template>
                          <template v-slot:[`item.aggiunge`]="{ item }">
                            {{ item.aggiunge ? 'SI' : 'NO' }}
                          </template>
                          <template v-slot:[`item.toglie`]="{ item }">
                            {{ item.toglie ? 'SI' : 'NO' }}
                          </template>
                          <template v-slot:[`item.deltaPrezzoPiu`]="{ item }">
                            {{ item.aggiunge ? item.deltaPrezzoPiu : '---' }}
                          </template>
                          <template v-slot:[`item.deltaPrezzoMeno`]="{ item }">
                            {{ item.toglie ? item.deltaPrezzoMeno : '---' }}
                          </template>
                          <template v-slot:[`item.sostituisce`]="{ item }">
                            {{ item.sostituisce ? item.sostituisce.descrizione : '' }}
                          </template>                        
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
              </v-tabs-items>
            </v-tab-item>
            <v-tab-item key="preparazioni">
              <v-tabs v-model="tabsPreparazioni">
                <v-tab v-for="(preparazione, index) in preparazioni" :key="index">{{ preparazione.categoria }}</v-tab>
                <!-- <v-btn icon title="Aggiungi un elemento" class="ml-3 mt-2" @click="tabsAddElement(variazione)"><v-icon>mdi-table-column-plus-after</v-icon></v-btn> -->
              </v-tabs>
              <v-tabs-items v-model="tabsPreparazioni">
                <v-tab-item v-for="(item, vdx) in preparazioni" :key="vdx">
                  <v-container fluid>
                    <v-row no-gutters>  
                      <v-col>
                        <v-data-table
                          v-model="preparazioniSelected"
                          :headers="preparazioniHeaders"
                          :items="item.preparazioni"
                          item-key="codice"
                          show-select
                          class="elevation-1"
                        >
                        <template v-slot:top>
                          <v-toolbar flat>
                            <v-toolbar-title>Seleziona le preparazioni da aggiungere</v-toolbar-title>
                            <v-btn class = "ml-5" small color="success" @click.stop="onAggiungiTuttePreparazioni(item.categoria)">Seleziona tutte</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn class = "ml-5" small color="primary" @click.stop="onAggiungiPreparazioniAlProdotto(item.categoria, item)">Aggiungi al prodotto</v-btn>
                          </v-toolbar>
                        </template>                          
                          <template v-slot:[`item.deltaPrezzo`]="{ item }">
                            {{ item.deltaPrezzo ? item.deltaPrezzo : '---' }}
                          </template>                      
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
              </v-tabs-items>
            </v-tab-item>            
          </v-tabs-items>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="blue darken-1" text @click="deleteItemConfirm">SI</v-btn> -->
          <v-btn color="blue darken-1" text @click="dialogVariazioni=false">CHIUDI</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>            
</template>

<script>
  import configurazioni from '@/services/configurazioniService'
  export default {
    components: {
    },
    props: {
      item: Object,
      refresh: Number,
      showDialog: { type: Boolean, default: false },
      editType: String
    },
    data () {
      return {
        tabs: null,
        tabsVariazioni: null,
        tabsPreparazioni: null,
        updateTrigger: 1,
        variazioni: [],
        preparazioni: [],
        prodottiDistinta: [],
        dialogVariazioni: false,
        editedIndex: -1,
        editedItem: null,
        variazioniSelected: [],
        variazioniHeaders: [
          { text: 'CODICE', value: 'codice' },
          { text: 'PRODOTTO', value: 'isProdotto' },
          { text: 'DESCRIZIONE', value: 'descrizione' },
          { text: 'AGGIUNGE', value: 'aggiunge' },
          { text: 'SOTTRAE', value: 'toglie' },
          { text: 'PREZZO +', value: 'deltaPrezzoPiu' },
          { text: 'PREZZO -', value: 'deltaPrezzoMeno' },
          { text: 'SOSTITUISCE', value: 'sostituisce' }
        ],
        preparazioniSelected: [],
        preparazioniHeaders: [
          { text: 'CODICE', value: 'codice' },
          { text: 'DESCRIZIONE', value: 'descrizione' },
          { text: 'DELTA PREZZO', value: 'deltaPrezzo' }
        ]           
      }
    },
    watch: {
      async showDialog(value) {
        if (value) {
          this.tabs = this.editType === 'variazioni' ? 0 : 1
          this.tabsPreparazioni = 0
          this.tabsVariazioni = 0
          this.dialogVariazioni = true
        }
      }
    },
    async mounted() {
      const menu = await configurazioni.getConfigurazione('menu')
      this.variazioni = menu.variazioni.filter(x => x.elencoCategorie === null)
      this.preparazioni = menu.preparazioni
    },
    computed: {
    
    },
    methods: {
      onAggiungiTutteVariazioni(categoria) {
        const daAggiungere = this.variazioni.find(x => x.categoria === categoria)
        this.variazioniSelected = [...daAggiungere.variazioni]
      },
      async onAggiungiVariazioniAlProdotto(categoria, item) {
        const codiceCategoria = item.codice
        if (this.variazioniSelected.length > 0) {
          const daAggiungere = this.variazioniSelected.map(x => {
            return {
              categoria: categoria,
              codiceCategoria: codiceCategoria,
              ...x
            }
          })
          this.$emit('aggiornaVariazioni', daAggiungere)
          this.annullaSelezioneVariazioni()
        }          
      },
      annullaSelezioneVariazioni() {
        while(this.variazioniSelected.length > 0) { this.variazioniSelected.pop() }
      },
      onAggiungiTuttePreparazioni(categoria) {
        const daAggiungere = this.preparazioni.find(x => x.categoria === categoria)
        this.preparazioniSelected = [...daAggiungere.preparazioni]
      },
      async onAggiungiPreparazioniAlProdotto(categoria, item) {
        if (this.preparazioniSelected.length > 0) {
          const codiceCategoria = item.codice
          const daAggiungere = this.preparazioniSelected.map(x => {
            return {
              categoria: categoria,
              codiceCategoria: codiceCategoria,
              ...x
            }
          })
          this.$emit('aggiornaPreparazioni', daAggiungere)
          this.annullaSelezionePreparazioni()
        }          
      },
      annullaSelezionePreparazioni() {
        while(this.preparazioniSelected.length > 0) { this.preparazioniSelected.pop() }
      }      
    }
}
</script>
